import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import isEmpty from '../../utils/isEmpty';
import StreamField from '../../components/StreamField';
import styles from './NewsDetailPage.module.scss';
import NewsListModule from '../../components/NewsListModule';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Hero from '../../components/Hero';
import i18n from '../../i18n';

const NewsDetailPage = ({
    breadcrumbs,
    hero,
    contentBlocks,
    title,
    firstPublishedAt,
    news,
}) => {
    return (
        <div className={styles['NewsDetailPage']}>
            {!isEmpty(hero) && <Hero {...hero} />}
            <div className={styles['NewsDetailPage__Container']}>
                <Breadcrumbs {...breadcrumbs} modifier="ArticlePage"/>

                <h1 className={styles['NewsDetailPage__Title']}>{title}</h1>
                <div className={styles['NewsDetailPage__Published']}>
                    {i18n.t('newsDetailPage.publishedAt')} {firstPublishedAt}
                </div>
            </div>

            {!isEmpty(contentBlocks) && <StreamField items={contentBlocks} modifier="ArticlePage" />}

            <div className={styles['NewsDetailPage__More']}>
                <NewsListModule
                    {...news}
                    heading={i18n.t('newsDetailPage.moreHeading')}
                />
            </div>
        </div>
    );
};

NewsDetailPage.propTypes = {
    navigation: PropTypes.object,
    title: PropTypes.string.isRequired,
    firstPublishedAt: PropTypes.string.isRequired,
    contentBlocks: PropTypes.array,
    hero: PropTypes.object,
};

NewsDetailPage.defaultProps = {
    navigation: {},
    title: '',
    firstPublishedAt: '',
    contentBlocks: [],
    hero: {},
};

export default basePageWrap(NewsDetailPage);
